import { api } from '@/lib/axios';
import type {
  GenericVideo,
  GenericVideoFormData,
  GenericDashboardStats,
  GenericMemoryListItem,
} from '@/types/genericVideo';

export const genericVideoService = {
  async list(): Promise<GenericVideo[]> {
    const { data } = await api.get<{ generic_videos: GenericVideo[] }>('/v1/admin/generic_videos');
    return data.generic_videos;
  },

  async create(formData: GenericVideoFormData): Promise<GenericVideo> {
    const { data } = await api.post<{ generic_video: GenericVideo }>('/v1/admin/generic_videos', {
      generic_video: {
        name: formData.name,
        description: formData.description,
        portadilla_enabled: formData.portadillaEnabled,
        portadilla_text: formData.portadillaText,
        video_blob_id: formData.videoBlobId,
      },
    });
    return data.generic_video;
  },

  async update(id: string, formData: Partial<GenericVideoFormData>): Promise<GenericVideo> {
    const payload: Record<string, unknown> = {
      name: formData.name,
      description: formData.description,
      portadilla_enabled: formData.portadillaEnabled,
      portadilla_text: formData.portadillaText,
    };
    if (formData.videoBlobId) {
      payload.video_blob_id = formData.videoBlobId;
    }
    const { data } = await api.patch<{ generic_video: GenericVideo }>(`/v1/admin/generic_videos/${id}`, {
      generic_video: payload,
    });
    return data.generic_video;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/v1/admin/generic_videos/${id}`);
  },

  async dashboard(filter?: string, startDate?: string, endDate?: string): Promise<GenericDashboardStats> {
    const params = new URLSearchParams();
    if (filter) params.set('filter', filter);
    if (startDate) params.set('start_date', startDate);
    if (endDate) params.set('end_date', endDate);
    const { data } = await api.get<GenericDashboardStats>(`/v1/admin/generic_videos/dashboard?${params}`);
    return data;
  },

  async memories(videoId: string, params?: { search?: string; page?: number }): Promise<{
    memories: GenericMemoryListItem[];
    total_count: number;
    page: number;
    per_page: number;
  }> {
    const searchParams = new URLSearchParams();
    if (params?.search) searchParams.set('search', params.search);
    if (params?.page) searchParams.set('page', params.page.toString());
    const { data } = await api.get(`/v1/admin/generic_videos/${videoId}/memories?${searchParams}`);
    return data;
  },
};
